import React from 'react';
import { useNavigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { XCircle, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { MinnowLogoFull } from '../components/MinnowLogo';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-2xl mx-auto px-4 py-16">
        <div className="text-center mb-8">
          <MinnowLogoFull variant="blue" logoSize={48} />
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          <Card className="rounded-2xl border-0 shadow-lg">
            <CardContent className="p-8 text-center">
              <div className="w-20 h-20 rounded-full bg-muted flex items-center justify-center mx-auto mb-6">
                <XCircle className="w-12 h-12 text-muted-foreground" />
              </div>
              
              <h1 className="text-2xl font-bold text-foreground mb-2">Payment Cancelled</h1>
              <p className="text-muted-foreground mb-8">
                No worries! Your payment was cancelled and you won't be charged. 
                You can continue with your current plan or try again when you're ready.
              </p>

              <div className="bg-sand-beige/30 rounded-xl p-4 mb-8">
                <p className="text-sm text-muted-foreground">
                  <strong>Still curious?</strong> Try our 7-day free trial to experience Basic tier features with no credit card required.
                </p>
              </div>

              <div className="flex flex-col sm:flex-row gap-4 justify-center">
                <Button 
                  onClick={() => navigate('/dashboard')}
                  variant="outline"
                  className="rounded-xl"
                >
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Back to Dashboard
                </Button>
                <Button 
                  onClick={() => navigate('/settings')}
                  className="gradient-ocean text-white rounded-xl"
                >
                  View Plans
                </Button>
              </div>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
